import { atom } from 'jotai';
import {
  FileViewerState,
  FileAiChatsData,
  ViewerSettings,
} from '@/types/fileViewer';

// 초기 뷰어 설정
export const INIT_VIEWER_SETTINGS: ViewerSettings = {
  zoom: 100,
  rotation: 0,
  currentPage: 1,
  totalPages: 1,
  viewMode: 'fit',
};

// 초기 파일 뷰어 상태
export const INIT_FILE_VIEWER_STATE: FileViewerState = {
  isOpen: false,
  file: null,
  settings: INIT_VIEWER_SETTINGS,
  isAiPanelOpen: false,
};

// 파일 뷰어 상태 Atom
export const FileViewerStateAtom = atom<FileViewerState>(
  INIT_FILE_VIEWER_STATE,
);

// AI 채팅 상태 Atom (팝업 닫으면 초기화)
export const FileAiChatsStateAtom = atom<FileAiChatsData>({});

// 추천 프롬프트 Atom (추후 서버에서 받아올 예정, 현재는 하드코딩)
export const RecommendedFilePromptAtom = atom<string>(
  '이 파일의 핵심 내용을 요약해주세요.',
);
